export default "__VITE_ASSET__DPRzP0yW__"